import clsx from 'clsx';
import { containerVariants } from './Container.cva';

export function Container({
  type = 'default',
  className,
  contentClassName,
  hasPadding,
  children,
}: {
  type?: 'default' | 'main' | 'mainNoFooter';
  className?: string;
  contentClassName?: string;
  hasPadding?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={containerVariants({
        type,
        hasPadding,
        className,
      })}
    >
      <div className={clsx('max-w-[1440px] flex flex-1 m-auto', contentClassName)}>{children}</div>
    </div>
  );
}
